import { HomePicture } from './HomePicture';
export default HomePicture;
